var _ellipse, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAteKuyaHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 830,
    height: 350,
    viewBox: "560 285 830 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 972.5,
    cy: 487,
    rx: 395.5,
    ry: 126,
    fill: "#EFE7D3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1603_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633.129 617.589L631.346 585.632L646.167 584.805L641.505 501.253L626.684 502.08L624.901 470.123L697.985 466.045L699.769 498.002L688.56 498.627L690.494 533.271L724.871 496.601L713.663 497.227L711.88 465.27L772.83 461.869L774.613 493.826L762.108 494.523L727.314 530.38L730.833 530.184C742.072 529.556 750.593 531.837 756.396 537.027C762.195 542.154 765.513 549.991 766.349 560.537L766.963 568.215C767.27 571.481 768.118 573.912 769.507 575.507C770.956 577.036 773.285 577.712 776.496 577.532L786.315 576.985L788.098 608.942L755.863 610.74C744.069 611.398 735.179 609.169 729.194 604.052C723.268 598.869 719.949 591.002 719.236 580.449L718.363 568.139C717.627 558.269 712.781 553.584 703.827 554.084L691.693 554.761L693.223 582.179L705.728 581.481L707.511 613.438L633.129 617.589Z",
    fill: "#224541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.178 609.247C868.338 609.632 852.071 604.674 840.375 594.373C828.741 584.072 822.711 567.357 822.284 544.23L821.323 492.1L806.481 492.373L805.891 460.372L884.271 458.927L884.862 490.928L869.557 491.21L870.52 543.433C870.88 562.974 879.161 572.595 895.363 572.296C903.093 572.153 908.797 569.512 912.476 564.372C916.216 559.23 918 551.96 917.826 542.56L916.863 490.338L901.558 490.62L900.968 458.619L962.095 457.491L962.685 489.493L947.844 489.766L948.874 545.606C949.643 587.286 929.744 608.499 889.178 609.247Z",
    fill: "#224541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.04 605.513L1013.64 573.512L1040.54 574.01L1041.16 540.618L999.052 489.452L985.602 489.203L986.196 457.201L1070.05 458.757L1069.46 490.758L1059.25 490.569L1077.02 512.889L1093.02 491.195L1082.81 491.006L1083.41 459.004L1142.21 460.095L1141.62 492.097L1128.17 491.847L1088.24 543.44L1087.66 574.884L1114.56 575.383L1113.97 607.385L1013.04 605.513Z",
    fill: "#224541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.86 608.316L1160.63 576.359L1174.07 577.105L1206.41 495.092L1186.49 493.985L1188.27 462.028L1279.79 467.115L1308.01 584.551L1321.44 585.298L1319.66 617.255L1236.58 612.636L1238.35 580.679L1253.64 581.528L1250.28 565.081L1212.11 562.96L1206.39 578.902L1221.68 579.752L1219.9 611.709L1158.86 608.316ZM1220.25 540.183L1245.45 541.584L1236.19 495.911L1220.25 540.183Z",
    fill: "#224541"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1603_46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.93 454.609L712.973 420.931L727.127 420.529L753.812 331.649L732.824 332.246L731.867 298.568L828.312 295.826L868.281 416.517L882.435 416.115L883.393 449.792L795.83 452.281L794.873 418.603L810.98 418.146L806.004 401.19L765.786 402.333L761.195 419.561L777.302 419.103L778.259 452.781L713.93 454.609ZM772.316 377.724L798.868 376.969L785.122 329.88L772.316 377.724Z",
    fill: "#AD5D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.104 449.719L921.137 416.028L949.458 416.056L949.548 326.017L932.068 326L928.129 358.906L895.902 358.874L895.967 294.225L1053.97 294.384L1053.91 359.033L1021.68 359L1017.81 326.086L1000.33 326.068L1000.24 416.107L1028.56 416.136L1028.53 449.827L921.104 449.719Z",
    fill: "#AD5D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.4 450.181L1070.38 416.504L1085.99 416.957L1088.55 328.908L1072.93 328.455L1073.91 294.778L1212.13 298.788L1210.34 360.578L1178.12 359.644L1175.54 330.943L1138.15 329.859L1137.39 356.215L1163.74 356.979L1162.78 390.169L1136.42 389.404L1135.57 418.884L1172.95 419.968L1177.33 387.171L1209.54 388.106L1207.62 454.191L1069.4 450.181Z",
    fill: "#AD5D4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1603_46",
    x: 623.9,
    y: 457.201,
    width: 710.962,
    height: 169.388,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.905882 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1603_46"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1603_46",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1603_46",
    x: 708.513,
    y: 294.225,
    width: 510.617,
    height: 169.384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.905882 0 0 0 0 0.827451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1603_46"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1603_46",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAteKuyaHero);
export default __webpack_public_path__ + "static/media/AteKuyaHero.ecf3c213890918ebbab6cce078191ac1.svg";
export { ForwardRef as ReactComponent };